export const AdviserHasBeenOpenedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'rec_comenzar',
    Mensaje: 'El usuario abrió el recomendador'
  });
}

export const StartButtonGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'evento2',
    // 'eventCategory': 'recomendador - apertura - btn',
    // 'eventAction': 'click to action', 
    // 'eventLabel': 'quiero comenzar',
    // 'origen': 'photofest.cl',
    // 'segmento': 'fijo', 
    'mercado': 'valor', 
    // 'page_owner': 'publico',
    // 'visitor_type' : 'no cliente',
    // 'form_name': 'Boton iniciar',
});
}